import React from "react";
import styled from "react-emotion";
import { css } from "react-emotion";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

const StyledMenu = styled("nav")`
  display: flex;
  flex-direction: column;
  justify-content: end;
  text-align: left;
  position: fixed;
  top: 0;
  left: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  z-index: 2;
  width: 100vh;
  height: 100%;
  background: #ffffff00;
  overflow: hidden;

  a {
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 0.5rem;
    color: white;
    text-decoration: none;
    transition: color 0.3s linear;
    width: 60%;
    border-bottom: 0.5px solid white;

    @media (min-width: 414px) {
      width: 70%;
    }

    span {
      font-size: 25px;
    }

    @media (max-width: 576px) {
      font-size: 1.5rem;
      text-align: center;
    }
  }
`;

const mdcButton = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const AButton = styled("a")`
  text-decoration: none;
  display: inline-block;
  @media (max-width: 576px) {
    font-size: 1.5rem;
    text-align: center;
  }
`;

function Menu({ open, menuOptions }) {
  open
    ? (document.body.style.overflow = "hidden")
    : (document.body.style.overflow = "auto");

  return (
    <StyledMenu open={open}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          background: "rgb(137, 210, 211)",
          width: "380px",
          justifyContent: "flex-start",
          textAlign: "right",
          height: "100%",
          overflow: "hidden",
          marginLeft: "150px",
          paddingTop: "50px",
        }}
      >
        {menuOptions.map(function (key, index) {
          return (
            <AButton key={`${key.listText}`} onClick={key.listFunc}>
              <Button className={mdcButton}>
                <span
                  style={{
                    color: "white",
                    textTransform: "capitalize",
                  }}
                >
                  {key.listText}
                </span>
              </Button>
            </AButton>
          );
        })}
      </div>
    </StyledMenu>
  );
}

Menu.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default Menu;
